module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "11.387b48f3.jpg";